import { useEffect, useState } from "react";

import { applyHomeEndKey } from "@recruiter/shared";

// "Simulate talent X" — a free-text identity picker. Talent ids are arbitrary
// shortlist ids the client chose (Fiverr usernames in production), so the tester
// types the one they want to act as. Testing-only stub identity, not real auth.
export function SellerSwitcher({
  sellerId,
  onSwitch,
  onBrowse,
}: {
  sellerId: string;
  onSwitch: (next: string) => void;
  // Clear the current identity → return to the talent picker (directory).
  onBrowse: () => void;
}) {
  const [draft, setDraft] = useState(sellerId);

  // Keep the input in sync if the id changes elsewhere (e.g. on load).
  useEffect(() => setDraft(sellerId), [sellerId]);

  const dirty = draft.trim() !== sellerId;

  function submit(e: React.FormEvent): void {
    e.preventDefault();
    if (draft.trim()) onSwitch(draft.trim());
  }

  return (
    <form className="sl-switcher" onSubmit={submit}>
      <div className="sl-switcher__label">Acting as talent</div>
      <div className="sl-switcher__row">
        <input
          className="sl-input"
          value={draft}
          placeholder="talent id…"
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={applyHomeEndKey}
          aria-label="Talent id to simulate"
        />
        <button className="sl-btn" type="submit" disabled={!draft.trim() || !dirty}>
          Switch
        </button>
      </div>
      <button type="button" className="sl-btn sl-btn--ghost sl-switcher__browse" onClick={onBrowse}>
        ← Browse all talents
      </button>
      <div className="sl-hint">Pick from the list, or type the id the client shortlisted.</div>
    </form>
  );
}
